// extracted by css-extract-rspack-plugin
export default {"fieldContainer":"_faac10e9"};